// extracted by mini-css-extract-plugin
export default {"sidebarnavigator":"f7ab4971392e2fde4131","container":"a5ca3a3b719025e2ed1f"};